import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const IconList = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function IconList({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M4.75 6.25C5.44036 6.25 6 5.69036 6 5C6 4.30964 5.44036 3.75 4.75 3.75C4.05964 3.75 3.5 4.30964 3.5 5C3.5 5.69036 4.05964 6.25 4.75 6.25Z'
        fill={color}
      />
      <path
        d='M21 5.25C21 5.52614 20.7761 5.75 20.5 5.75H9.5C9.22386 5.75 9 5.52614 9 5.25V4.75C9 4.47386 9.22386 4.25 9.5 4.25H20.5C20.7761 4.25 21 4.47386 21 4.75V5.25Z'
        fill={color}
      />
      <path
        d='M21 12.25C21 12.5261 20.7761 12.75 20.5 12.75H9.5C9.22386 12.75 9 12.5261 9 12.25V11.75C9 11.4739 9.22386 11.25 9.5 11.25H20.5C20.7761 11.25 21 11.4739 21 11.75V12.25Z'
        fill={color}
      />
      <path
        d='M20.5 19.75C20.7761 19.75 21 19.5261 21 19.25V18.75C21 18.4739 20.7761 18.25 20.5 18.25H9.5C9.22386 18.25 9 18.4739 9 18.75V19.25C9 19.5261 9.22386 19.75 9.5 19.75H20.5Z'
        fill={color}
      />
      <path
        d='M6 12C6 12.6904 5.44036 13.25 4.75 13.25C4.05964 13.25 3.5 12.6904 3.5 12C3.5 11.3096 4.05964 10.75 4.75 10.75C5.44036 10.75 6 11.3096 6 12Z'
        fill={color}
      />
      <path
        d='M4.75 20.25C5.44036 20.25 6 19.6904 6 19C6 18.3096 5.44036 17.75 4.75 17.75C4.05964 17.75 3.5 18.3096 3.5 19C3.5 19.6904 4.05964 20.25 4.75 20.25Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'icon-list-icon-svg'} iconRender={iconRender} {...props} />;
});

export default IconList;
